"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = DoubleScrollbar;
var _react = _interopRequireWildcard(require("react"));
var _style = _interopRequireDefault(require("./style.css"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function DoubleScrollbar(_ref) {
  var children = _ref.children;
  var _useState = (0, _react.useState)('auto'),
    _useState2 = _slicedToArray(_useState, 2),
    width = _useState2[0],
    setWidth = _useState2[1];
  var topScrollbarRef = (0, _react.useRef)();
  var childrenRef = (0, _react.useRef)();
  var calculateWidth = (0, _react.useCallback)(function () {
    var newWidth = getChildWrapperWidth();
    setWidth(newWidth);
  }, []);
  (0, _react.useEffect)(function () {
    calculateWidth();
    window.addEventListener('resize', calculateWidth);
    return function () {
      window.removeEventListener('resize', calculateWidth);
    };
  }, []);
  (0, _react.useEffect)(function () {
    calculateWidth();
  }, [children]);
  function getChildWrapperWidth() {
    if (childrenRef.current && childrenRef.current.scrollWidth) {
      return childrenRef.current.scrollWidth + 'px';
    }
    return 'auto';
  }
  function handleScrollTop() {
    childrenRef.current.scrollLeft = topScrollbarRef.current.scrollLeft;
  }
  function handleScrollChildren() {
    topScrollbarRef.current.scrollLeft = childrenRef.current.scrollLeft;
  }
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].topScrollbarOuter,
    ref: topScrollbarRef,
    onScroll: handleScrollTop
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].topScrollbarInner,
    style: {
      width: width
    }
  }, "\xA0")), /*#__PURE__*/_react["default"].createElement("div", {
    className: _style["default"].children,
    ref: childrenRef,
    onScroll: handleScrollChildren,
    "data-table-scroll-wrapper": true
  }, children));
}